import { FC, useEffect, Dispatch, SetStateAction } from "react";
import { Checkbox } from "src/atoms/Checkbox";

interface Props {
  shouldAddToStorefront: boolean;
  setShouldAddToStorefront: Dispatch<SetStateAction<boolean>>;
}

const AddToStorefrontCheckbox: FC<Props> = ({
  shouldAddToStorefront,
  setShouldAddToStorefront,
}) => {
  useEffect(() => {
    const shouldAddToStorefrontFromLocalStorage = localStorage.getItem(
      "shouldAddToStorefront"
    );
    if (shouldAddToStorefrontFromLocalStorage) {
      setShouldAddToStorefront(
        shouldAddToStorefrontFromLocalStorage === "true"
      );
    }
  }, [setShouldAddToStorefront]);

  const toggleAddToStorefront = () => {
    setShouldAddToStorefront((prevShouldAddToStorefront: boolean) => {
      window.localStorage.setItem(
        "shouldAddToStorefront",
        JSON.stringify(!prevShouldAddToStorefront)
      );
      return !prevShouldAddToStorefront;
    });
  };

  return (
    <Checkbox checked={shouldAddToStorefront} onChange={toggleAddToStorefront}>
      Add to Storefront
    </Checkbox>
  );
};

export default AddToStorefrontCheckbox;
